import * as React from 'react';
import './Loading.css';
import { Panel } from 'react-bootstrap';
const loading = require('./loading.svg') as string;

interface LoadingIndicatorProps {
    showBackground?: boolean;
    showInPanel?: boolean;
    showPdfDescription?: boolean;
}

export class LoadingIndicator extends React.Component<LoadingIndicatorProps> {
    render() {
        let component = <img src={loading} alt="loading" />;

        if (this.props.showPdfDescription === true) {
            component = (
                <React.Fragment>
                    {component}
                    <div className="loading-text">Generating Report...</div>
                    <div className="text-muted">This operation may take a few minutes to complete.</div>
                </React.Fragment>
            );
        }

        if (this.props.showInPanel === true) {
            component = (
                <Panel className="loading-panel">
                    <Panel.Body className="loading-panel-body">
                        {component}
                    </Panel.Body>
                </Panel>
            );
        }
        
        if (this.props.showBackground === true) {
            return (
                <div className="loading-container with-background">
                    {component}
                </div>);
        } else {
            return (
                <div className="loading-container">
                    {component}
                </div>);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/loadingIndicator/LoadingIndicator.tsx